import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { api } from 'services/api';
import { patientsApi } from 'services/patientsApi';
import authReducer from '../modules/auth/authSlice';
import gdpReducer from '../modules/gdp/gdpSlice';
import appSlice from './appSlice';
import caseReducer from './caseSlice';
import eduContentReducer from 'components/edu-content/edu-content-list/eduContentSlice';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const reducers = combineReducers({
  [api.reducerPath]: api.reducer,
  [patientsApi.reducerPath]: patientsApi.reducer,
  auth: authReducer,
  gdp: gdpReducer,
  app: appSlice,
  case: caseReducer,
  eduContent: eduContentReducer,
});

export const middlewares = [api.middleware];

export default persistReducer(persistConfig, reducers);
